const prepositions = {
  de: {
    accusative: [
      {
        id: '1',
        term: 'durch',
        description1: 'through',
        description2: 'Der Geist geht durch die Tür.',
      },
      {
        id: '2',
        term: 'entlang',
        description1: 'along',
        description2: 'Das Gespenst geht die Straße entlang.',
      },
      {
        id: '3',
        term: 'für',
        description1: 'for',
        description2: 'Das Grab ist für dich.',
      },
      {
        id: '4',
        term: 'gegen',
        description1: 'against',
        description2: 'Der Zombie gegen den Dämon.',
      },
      {
        id: '5',
        term: 'ohne',
        description1: 'without',
        description2: 'Die Hexe mag Kaffee ohne Milch.',
      },
      {
        id: '6',
        term: 'um',
        description1: 'around',
        description2: 'Der Vampir ist um die Ecke.',
      },
    ],
    dative: [
      {
        id: '1',
        term: 'aus',
        description1: 'from (place, origin); from, out of (material)',
        description2: 'Wenn der Mond voll ist, kommt der Werwolf aus der Scheune. Die Schuhe des Werwolfs sind aus Holz.',
      },
      {
        id: '2',
        term: 'außer',
        description1: 'except, apart from',
        description2: 'Außer dem Hund war das Haus leer.',
      },
      {
        id: '3',
        term: 'bei',
        description1: 'by, at, with, next to',
        description2: 'Ich arbeite bei Calvin Klein.',
      },
      {
        id: '4',
        term: 'mit',
        description1: 'with',
        description2: 'Ich fahre nach Berlin mit dem Zug.',
      },
      {
        id: '5',
        term: 'nach',
        description1: 'after, to (direction)',
        description2: 'Ich fliege heute nach Bremen.',
      },
      {
        id: '6',
        term: 'seit',
        description1: 'since',
        description2: 'Maria lernt seit einem Jahr Deutsch',
      },
      {
        id: '7',
        term: 'von',
        description1: 'from, of',
        description2: 'Das Geschenk ist von meiner Mutter.',
      },
      {
        id: '8',
        term: 'zu',
        description1: 'to',
        description2: 'Ich gehe zu der Bank.',
      },
    ],
    twoWay: [
      {
        id: '1',
        term: 'an',
        description1: 'on (leaning against and touching); at (by or at the point of reference)',
        description2: 'Die Frau hängt das Bild an der Wand, nachdem sie sie angestrichen hat. Ihre Kinder sitzen an dem Tisch. (Her children sit at the table).',
      },
      {
        id: '2',
        term: 'auf',
        description1: 'on (on top of)',
        description2: 'Die Mutter sitzt ein kleines kind auf den Tisch weil ihr Mann auf dem Stuhl sitzt.',
      },
      {
        id: '3',
        term: 'hinter',
        description1: 'behind',
        description2: 'Ich weiß nicht, ob der Hund hinter dem Sofa ist.',
      },
      {
        id: '4',
        term: 'in',
        description1: 'in, inside',
        description2: 'Markus wird in dem Baum sitzen, sofern der Hund unter dem Baum ist.',
      },
      {
        id: '5',
        term: 'neben',
        description1: 'next to',
        description2: 'Der Tisch ist neben dem grünen Sofa.',
      },
      {
        id: '6',
        term: 'über',
        description1: 'over',
        description2: 'Der Vogel fliegt über den Baum aber unter die Wolken.',
      },
      {
        id: '7',
        term: 'unter',
        description1: 'under',
        description2: 'Der Hund ist unter dem Baum weil das Eichhörnchen im Baum sitzt.',
      },
      {
        id: '8',
        term: 'vor',
        description1: 'in front of',
        description2: 'Das Kind steht vor dem Fernseher.',
      },
      {
        id: '9',
        term: 'zwischen',
        description1: 'between',
        description2: 'Die Lampe sitzt zwischen den Stühlen.',
      },
    ],
    genitive: [
      {
        id: '1',
        term: 'anstatt',
        description1: '',
        description2: '',
      },
      {
        id: '2',
        term: 'aufgrund',
        description1: '',
        description2: '',
      },
      {
        id: '3',
        term: 'alßerhalb',
        description1: '',
        description2: '',
      },
      {
        id: '4',
        term: 'dank',
        description1: '',
        description2: '',
      },
      {
        id: '5',
        term: 'statt',
        description1: '',
        description2: '',
      },
      {
        id: '6',
        term: 'während',
        description1: '',
        description2: '',
      },
      {
        id: '7',
        term: 'wegen',
        description1: '',
        description2: '',
      },
    ],
  },
  nl: {
    all: [
      {
        id: '1',
        term: 'aan',
        description1: 'on, upon, at, to',
        description2: '',
      },
      {
        id: '2',
        term: 'achter',
        description1: 'behind',
        description2: '',
      },
      {
        id: '3',
        term: 'beneden',
        description1: 'beneath, below',
        description2: '',
      },
      {
        id: '4',
        term: 'bij',
        description1: 'by, with, near',
        description2: '',
      },
      {
        id: '5',
        term: 'binnen',
        description1: 'within',
        description2: '',
      },
      {
        id: '6',
        term: 'boven',
        description1: 'above, over',
        description2: '',
      },
      {
        id: '7',
        term: 'buiten',
        description1: 'outside, out of',
        description2: '',
      },
      {
        id: '8',
        term: 'door',
        description1: 'through',
        description2: '',
      },
      {
        id: '9',
        term: 'gedurende',
        description1: 'during',
        description2: '',
      },
      {
        id: '10',
        term: 'in',
        description1: 'in, into, at, on',
        description2: '',
      },
      {
        id: '11',
        term: 'langs',
        description1: 'along',
        description2: '',
      },
      {
        id: '12',
        term: 'met',
        description1: 'with',
        description2: '',
      },
      {
        id: '13',
        term: 'na',
        description1: 'after',
        description2: '',
      },
      {
        id: '14',
        term: 'naar',
        description1: 'to, according to',
        description2: '',
      },
      {
        id: '15',
        term: 'naast',
        description1: 'next to',
        description2: '',
      },
      {
        id: '16',
        term: 'om',
        description1: 'around, at (time), for',
        description2: '',
      },
      {
        id: '17',
        term: 'omstreeks',
        description1: 'about, approximately',
        description2: '',
      },
      {
        id: '18',
        term: 'ondanks',
        description1: 'in spite of',
        description2: '',
      },
      {
        id: '19',
        term: 'onder',
        description1: 'underneath, among',
        description2: '',
      },
      {
        id: '20',
        term: 'op',
        description1: 'on, upon, in, at',
        description2: '',
      },
      {
        id: '21',
        term: 'over',
        description1: 'over, on top of, across',
        description2: '',
      },
      {
        id: '22',
        term: 'sedert',
        description1: 'since (temporal)',
        description2: '',
      },
      {
        id: '23',
        term: 'sinds',
        description1: 'since (temporal)',
        description2: '',
      },
      {
        id: '24',
        term: 'te',
        description1: 'at, in',
        description2: '',
      },
      {
        id: '25',
        term: 'tegen',
        description1: 'against',
        description2: '',
      },
      {
        id: '26',
        term: 'tot',
        description1: 'to, up to, until',
        description2: '',
      },
      {
        id: '27',
        term: 'tussen',
        description1: 'between',
        description2: '',
      },
      {
        id: '28',
        term: 'uit',
        description1: 'out of, from',
        description2: '',
      },
      {
        id: '29',
        term: 'van',
        description1: 'from, of, by',
        description2: '',
      },
      {
        id: '30',
        term: 'vanaf',
        description1: 'from',
        description2: '',
      },
      {
        id: '31',
        term: 'voor',
        description1: 'for, in front of, before',
        description2: '',
      },
      {
        id: '31',
        term: 'zonder',
        description1: 'without',
        description2: '',
      },
    ],
  },
  za: {
    accusative: [
      {
        id: '1',
        term: 'durch',
        description1: 'through',
        description2: 'Der Geist geht durch die Tür.',
      },
      {
        id: '2',
        term: 'entlang',
        description1: 'along',
        description2: 'Das Gespenst geht die Straße entlang.',
      },
      {
        id: '3',
        term: 'für',
        description1: 'for',
        description2: 'Das Grab ist für dich.',
      },
      {
        id: '4',
        term: 'gegen',
        description1: 'against',
        description2: 'Der Zombie gegen den Dämon.',
      },
      {
        id: '5',
        term: 'ohne',
        description1: 'without',
        description2: 'Die Hexe mag Kaffee ohne Milch.',
      },
      {
        id: '6',
        term: 'um',
        description1: 'around',
        description2: 'Der Vampir ist um die Ecke.',
      },
    ],
    dative: [
      {
        id: '1',
        term: 'aus',
        description1: 'from (place, origin); from, out of (material)',
        description2: 'Wenn der Mond voll ist, kommt der Werwolf aus der Scheune. Die Schuhe des Werwolfs sind aus Holz.',
      },
      {
        id: '2',
        term: 'außer',
        description1: 'except, apart from',
        description2: 'Außer dem Hund war das Haus leer.',
      },
      {
        id: '3',
        term: 'bei',
        description1: 'by, at, with, next to',
        description2: 'Ich arbeite bei Calvin Klein.',
      },
      {
        id: '4',
        term: 'mit',
        description1: 'with',
        description2: 'Ich fahre nach Berlin mit dem Zug.',
      },
      {
        id: '5',
        term: 'nach',
        description1: 'after, to (direction)',
        description2: 'Ich fliege heute nach Bremen.',
      },
      {
        id: '6',
        term: 'seit',
        description1: 'since',
        description2: 'Maria lernt seit einem Jahr Deutsch',
      },
      {
        id: '7',
        term: 'von',
        description1: 'from, of',
        description2: 'Das Geschenk ist von meiner Mutter.',
      },
      {
        id: '8',
        term: 'zu',
        description1: 'to',
        description2: 'Ich gehe zu der Bank.',
      },
    ],
    twoWay: [
      {
        id: '1',
        term: 'an',
        description1: 'on (leaning against and touching); at (by or at the point of reference)',
        description2: 'Die Frau hängt das Bild an der Wand, nachdem sie sie angestrichen hat. Ihre Kinder sitzen an dem Tisch. (Her children sit at the table).',
      },
      {
        id: '2',
        term: 'auf',
        description1: 'on (on top of)',
        description2: 'Die Mutter sitzt ein kleines kind auf den Tisch weil ihr Mann auf dem Stuhl sitzt.',
      },
      {
        id: '3',
        term: 'hinter',
        description1: 'behind',
        description2: 'Ich weiß nicht, ob der Hund hinter dem Sofa ist.',
      },
      {
        id: '4',
        term: 'in',
        description1: 'in, inside',
        description2: 'Markus wird in dem Baum sitzen, sofern der Hund unter dem Baum ist.',
      },
      {
        id: '5',
        term: 'neben',
        description1: 'next to',
        description2: 'Der Tisch ist neben dem grünen Sofa.',
      },
      {
        id: '6',
        term: 'über',
        description1: 'over',
        description2: 'Der Vogel fliegt über den Baum aber unter die Wolken.',
      },
      {
        id: '7',
        term: 'unter',
        description1: 'under',
        description2: 'Der Hund ist unter dem Baum weil das Eichhörnchen im Baum sitzt.',
      },
      {
        id: '8',
        term: 'vor',
        description1: 'in front of',
        description2: 'Das Kind steht vor dem Fernseher.',
      },
      {
        id: '9',
        term: 'zwischen',
        description1: 'between',
        description2: 'Die Lampe sitzt zwischen den Stühlen.',
      },
    ],
    genitive: [
      {
        id: '1',
        term: 'anstatt',
        description1: '',
        description2: '',
      },
      {
        id: '2',
        term: 'aufgrund',
        description1: '',
        description2: '',
      },
      {
        id: '3',
        term: 'alßerhalb',
        description1: '',
        description2: '',
      },
      {
        id: '4',
        term: 'dank',
        description1: '',
        description2: '',
      },
      {
        id: '5',
        term: 'statt',
        description1: '',
        description2: '',
      },
      {
        id: '6',
        term: 'während',
        description1: '',
        description2: '',
      },
      {
        id: '7',
        term: 'wegen',
        description1: '',
        description2: '',
      },
    ],
  },
};

export default prepositions;
